import {Injectable} from '@angular/core';
import { GlobalDataService } from '../../housekeeping/services/global-data.service';
import { FileUploadService } from '../../housekeeping/services/file-upload.service';
import { GlobalVariable } from '../../../../app/config';

@Injectable()
export class CaseService {
    public BASE_URL = GlobalVariable.FORDAPIEndPointURL;

    constructor(public _globalDataService:GlobalDataService) {}

    /**
     * @author Nagendra
     * @description Get User preferences
     */
    getcasePreference(userId,callback){
        this._globalDataService.GetAjaxCall(this.BASE_URL + "/lms/case/userPreference/get?userId="+userId, (result) => {
            callback(result);
        })
    }

    /**
     * @author Nagendra
     * @description Save User preferences
     */
    saveCasePreference(savePreference,callback){
        this._globalDataService.PostAjaxCall(this.BASE_URL + "/lms/case/userPreference/save",savePreference, (result) => {
        callback(result);
        })
    }

    /**
     * @author Nagendra
     * @description Get all field settings
     */
     getviewSettings(callback){
         this._globalDataService.GetAjaxCall(this.BASE_URL + "/lms/case/viewSettings/list", (result) => {
            callback(result);
        })
     }

     /**
      * @author Anand
      * @uses   Basic search
      */
     caseBasicSearch(userId,searchKey,offset,limit,column,sort,isLastNameExact,callback){
          this._globalDataService.GetAjaxCall(this.BASE_URL + "/lms/case/search?userId="+userId+"&searchKey="+searchKey+"&offset="+offset+"&pageLimit="+limit+"&orderBy="+column+"&sortBy="+sort+"&isLastNameExact="+isLastNameExact, (result) => {
            callback(result);
        })
     }

      /**
      * @author Anand
      * @uses   Advance search
      */
     caseAdvanceSearch(searchObj,callback){
          this._globalDataService.PostAjaxCall(this.BASE_URL + "/lms/case/searchWider",searchObj, (result) => {
            callback(result);
        })
     }

     /**
      * @author Anand
      * @uses   Get priority list
      */
     getPriorityList(userid,callback){
        this._globalDataService.GetAjaxCall(this.BASE_URL + "/lms/case/priority/list", (result) => {
            callback(result);
        })
    }

     /**
      * @author Anand
      * @uses   Get case type list
      */
     getCaseTypeList(userid,callback){
        this._globalDataService.GetAjaxCall(this.BASE_URL + "/lms/case/type/list", (result) => {
            callback(result);
        })
    }

     /**
      * @author Anand
      * @uses   Get case source list
      */
     getCaseSourceList(userid,callback){
        this._globalDataService.GetAjaxCall(this.BASE_URL + "/lms/case/source/list", (result) => {
            callback(result);
        })
    }

     /**
      * @author Anand
      * @uses   Get case status list
      */
     getStatusList(userid,callback){
        this._globalDataService.GetAjaxCall(this.BASE_URL + "/lms/case/status/list", (result) => {
            callback(result);
        })
    }

     /**
      * @author Anand
      * @uses   Get dealer list
      */
     getDealerList(userid,callback){
        this._globalDataService.GetAjaxCall(this.BASE_URL + "/lms/dealer/list?userId="+userid, (result) => {
            callback(result);
        })
    }

     /**
      * @author Pradeep
      * @uses   Get assignedto list
      */
     getAssignToList(userId,callback){
        this._globalDataService.GetAjaxCall(this.BASE_URL + "/lms/assigneto/list?userId="+userId, (result) => {
          result.sort(function (a,b){
            if(a.firstName < b.firstName){
              return -1
            }else if(a.firstName>b.firstName){
              return 1;
            }else{
              return 0;
            }
          });
          callback(result);
        })
    }

    /**
      * @author Sowmya
      * @uses   set DefaultPreference For Case
      */
    setDefaultPreferenceForCase(current,remaining) {
        current = [];
        remaining = [];
        this.getviewSettings(allPreference => {
            allPreference.forEach(Obj => {
                if (Obj.isDefult == true) {current.push(Obj.label)}
                if (Obj.isDefult == false) {remaining.push(Obj.label)}
            });

        });
        return [current,remaining];
    }

    /**
     * @author Nagendra
     * @param userid,offset,limit
     * @returns List of cases assigned to user
     */
    getCaseList(userid,offset,limit,column,sort,callback) {
        this._globalDataService.GetAjaxCall(this.BASE_URL + "/lms/case/list?userId="+ userid+"&offset="+offset+"&pageLimit="+limit+"&orderBy="+column+"&sortBy="+sort, (result) => {
        callback(result);
        })
    }
    /**
    * @author Ciocan Vlad
    * @uses view the leads detail page
    */
    viewCaseDetails(caseId,userId,callback){
        this._globalDataService.GetAjaxCall(this.BASE_URL + "/lms/case/details?userId=" + userId + "&caseId=" + caseId, (result) => {
            callback(result);
        })
    }
      /**
     * @author Pradeep
     * @param search obj
     * @returns List of owners
     */
     getSearchOwnerList(searchObj,callback){
        this._globalDataService.PostAjaxCall(this.BASE_URL + "/lms/owner/searchWider", searchObj,(result) => {
            callback(result);
        })
    }

         /**
     * @author Pradeep
     * @param user id
     * @returns List of case category
     */
     getcaseCategoryList(userId,callback){
        this._globalDataService.GetAjaxCall(this.BASE_URL + "/lms/case/category/list", (result) => {
            callback(result);
        })
    }

    /**
     * @author Pradeep
     * @param category id
     * @returns List of case sub category
     */
     getcaseSubCategoryList(categoryId,callback){
        this._globalDataService.GetAjaxCall(this.BASE_URL + "/lms/case/subcategory1/list?categoryId="+categoryId,(result) => {
            callback(result);
        })
    }

    /**
     * @author Pradeep
     * @param sub category id 1
     * @returns List of case sub category
     */
     getcaseSubCategory2List(subcategory1Id,callback){
        this._globalDataService.GetAjaxCall(this.BASE_URL + "/lms/case/subcategory2/list?subcategory1Id="+subcategory1Id,(result) => {
            callback(result);
        })
    }

     /**
     * @author Ciocan Vlad
     * @param
     * @returns get all vehicle make list
     */
     getMakeList(userId,callback){
       this._globalDataService.GetAjaxCall(this.BASE_URL + "/lms/brand/list", (result) => {
            callback(result);
        })
    }



    /**
     * @author Sowmya
     * @description get log Details for case
     */

     getCaseLogDetails(caseId,callback){
         this._globalDataService.GetAjaxCall(this.BASE_URL + "/lms/case/changeLog/list?id="+caseId, (result) => {
            callback(result);
        })
     }
    /**
     * @author Pradeep
     * @description save case Details
     */

     saveCase(caseObj,callback){
         this._globalDataService.PostAjaxCall(this.BASE_URL + "/lms/case/save", caseObj,(result) => {
            callback(result);
        })

     }
     /**
     * @author Pradeep
     * @description save dealer note details
     */
    saveCaseActivities(caseActivity, callback) {
        this._globalDataService.PostAjaxCall(this.BASE_URL + "/lms/case/activity/save", caseActivity, (result) => {

            callback(result);
        })
    }
    /**
     * @author Pradeep
     * @description delete dealer note details
     */
    deletCaseActivities(caseActivityid, callback) {
        this._globalDataService.GetAjaxCall(this.BASE_URL + "/lms/case/activityDelete?activityId=" + caseActivityid, (result) => {

            callback(result);
        })
    }
      /**
     * @author Pradeep
     * @description save case status Details
     */
    saveCaseStatus(userId,caseId,callback){
         this._globalDataService.GetAjaxCall(this.BASE_URL + "/lms/case/close?userId="+userId+"&caseId="+caseId,(result) => {
            callback(result);
        })

     }

    /**
     * @author Nagendra
     * @description Dropdown AssignedTo with full name
     */
    getAssignToWithFullName(userId,callback) {
      const temp = [];
      this._globalDataService.GetAjaxCall(this.BASE_URL + "/lms/assigneto/list?userId="+userId, (result) => {
        result.sort(function (a,b){
          if(a.firstName < b.firstName){
            return -1
          }else if(a.firstName>b.firstName){
            return 1;
          }else{
            return 0;
          }
        });
        result.forEach(obj => {
            temp.push({
                    id: obj.id,
                    firstName: obj.firstName,
                    lastName: obj.lastName,
                    fullName: obj.firstName+' '+obj.lastName
                })
            });
            callback(temp)
        })
    }
      updatePageLimit(userId, limit,callback){
       this._globalDataService.GetAjaxCall(this.BASE_URL + "/lms/user/updatePageLimit?userId=" + userId + "&pageLimit=" + limit, result => {
            callback(result);

        })
}

  /* @author Vanitha
     * @uses region list
     * @date 20-11-2019
     */

        getRegionList(callback){
        const temp = [];
        this._globalDataService.GetAjaxCall(this.BASE_URL + '/lms/user/region/list', (result) => {
        result.forEach(obj => {
        temp.push({
          id: obj.id,
          code: obj.code,
          description: obj.description,
          codeDescription: obj.code + '(' + obj.description + ')'
        })
        });
         callback(temp);
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/cases/services/case.service.ts